import React from 'react';
import './index.scss';
import _ from 'lodash';
import { BLOCKS } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

function KeyTakeawaysSection({
  keyTakeaways = {},
  id = 'keyTakeawaysSection',
  className = ''
}) {
  const renderOptions = links => {
    const entryBlockMap = new Map();

    if (links && !_.isEmpty(links.entries)) {
      for (const entry of links.entries.block) {
        entryBlockMap.set(entry.sys.id, entry);
      }
    }
    const assetBlockMap = new Map();
    if (links && !_.isEmpty(links.assets)) {
      for (const asset of links.assets.block) {
        assetBlockMap.set(asset.sys.id, asset);
      }
    }
    return {
      renderNode: {
        [BLOCKS.EMBEDDED_ENTRY]: node => {
          const entry = entryBlockMap.get(node.data.target.sys.id);
          return (
            <>
              {entry && entry.tableData && (
                <span
                  dangerouslySetInnerHTML={{
                    __html: entry.tableData
                  }}
                ></span>
              )}
            </>
          );
        },
        [BLOCKS.EMBEDDED_ASSET]: node => {
          const asset = assetBlockMap.get(node.data.target.sys.id);
          return (
            <img
              className="contentImg"
              src={asset.url}
              alt={asset.description}
              title={asset.title}
            />
          );
        }
      }
    };
  };

  return (
    <>
      {!_.isEmpty(keyTakeaways) && (
        <div className={`graySection ${className}`} id={id}>
          {keyTakeaways?.content[0]?.nodeType == 'heading-2' ? null : (
            <h2>Key takeaways</h2>
          )}
          {documentToReactComponents(
            keyTakeaways && (keyTakeaways?.json || keyTakeaways),
            renderOptions(keyTakeaways && keyTakeaways?.links)
          )}
        </div>
      )}
    </>
  );
}

export default KeyTakeawaysSection;
